import { API_URL } from '../../../../utils/config';

export const ADD_RELOCATION_REQUEST_URL = `${API_URL}/relocation`;
export const GET_RELOCATION_REQUEST_URL = `${API_URL}/relocation/fetchRelocation`;
export const EDIT_RELOCATION_REQUEST_URL = `${API_URL}/relocation/updateRelocation`;
